import { MATERIAL_TEXTS } from '../constants/materialDashboardConstants';

/**
 * Líneas del tooltip de información: alcance, cotización, cobertura y advertencias del backend.
 * @param {Object} [summary] Respuesta del resumen.
 * @returns {Array<string>}
 */
export const buildDashboardInfoLines = (summary) => {
  const totals = summary?.totals || {};
  return [
    MATERIAL_TEXTS.scope,
    `${MATERIAL_TEXTS.source} · ${MATERIAL_TEXTS.valuedAsOf} ${
      summary?.quote_as_of || MATERIAL_TEXTS.noQuote
    }`,
    MATERIAL_TEXTS.coverage(totals.line_count ?? 0, totals.unvalued_lines ?? 0),
    `${MATERIAL_TEXTS.nextDelivery}: ${totals.next_delivery || MATERIAL_TEXTS.noCommitment}`,
    ...(summary?.warnings || []),
  ];
};
